import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50a2fc5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLBidWaypoints" }
const _hoisted_2 = { class: "FTLBidWaypoints__container" }
const _hoisted_3 = { class: "container__block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Отправитель", -1))
const _hoisted_5 = {
  key: 0,
  class: "block__content"
}
const _hoisted_6 = { class: "block__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Отправной пункт", -1))
const _hoisted_8 = { class: "field__value" }
const _hoisted_9 = { class: "block__field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Наименование отправителя", -1))
const _hoisted_11 = { class: "field__value" }
const _hoisted_12 = { class: "block__field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Адрес отправителя", -1))
const _hoisted_14 = { class: "field__value" }
const _hoisted_15 = { class: "block__field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Контактное лицо", -1))
const _hoisted_17 = { class: "field__value" }
const _hoisted_18 = { class: "block__field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Номер отправителя", -1))
const _hoisted_20 = { class: "field__value" }
const _hoisted_21 = { class: "container__block" }
const _hoisted_22 = { class: "block__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ftl_additional_service = _resolveComponent("ftl-additional-service")!
  const _component_waypoint = _resolveComponent("waypoint")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.sender)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.sender.city_name), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.sender.sender_template)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.sender.sender_template.title || '-'), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.sender.sender_template)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.sender.sender_template.full_address || '-'), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.sender.sender_template)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.sender.sender_template.full_name || '-'), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.sender.sender_template)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.sender.sender_template.phone || '-') + ", " + _toDisplayString(_ctx.sender.sender_template.additional_phone || '-'), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.sender && Boolean(_ctx.sender.additional_service) && _ctx.sender.additional_service.length)
          ? (_openBlock(), _createBlock(_component_ftl_additional_service, {
              key: 1,
              "additional-service": _ctx.sender.additional_service
            }, null, 8, ["additional-service"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, "Остановки (" + _toDisplayString(_ctx.filteredWaypoints.length) + ")", 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredWaypoints, (waypoint, index) => {
        return (_openBlock(), _createBlock(_component_waypoint, {
          key: `bid-waypoint-${index}`,
          waypoint: waypoint,
          "bid-id": _ctx.bidId,
          index: index
        }, null, 8, ["waypoint", "bid-id", "index"]))
      }), 128))
    ])
  ]))
}